import { ReportingService } from './../../services/reporting.service';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ProcessDetailService } from './../../services/process-detail.service';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
  ViewChild,
  ElementRef,
  TemplateRef,
  ChangeDetectorRef,
} from '@angular/core';
import {
  ProcessDetail,
  ProcessDuration,
  ProcessParticipation,
  AppraiseeProcessDetail,
  ProcessActionNotificationType,
  ProcessStage,
  ProcessDurationAppraiseeStage,
} from '../../models/process-models';
import * as moment from 'moment';
import { NgxItem } from '../../models/common.share.model';
import { ProcessDetailFilter } from './models/process-detail-filter.model';
import { ProcessParticipationService } from '../../services/process.participation.service';
import { saveAs } from 'file-saver';
import { ConfigService } from '../../services/config.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import {
  IndividualDetailReport,
  ProcessInfoReport,
} from '../../models/reporting';
import * as FileSaver from 'file-saver';
import { RespondentState } from '../../models/process-models/respondent-state.enum';
import { ReopenProcessModalComponent } from '../../common/modal/reopen-process-modal/reopen-process-modal.component';
import { first } from 'rxjs/operators';
import { AddRespondentComponent } from '../../common/modal/add-respondent/add-respondent.component';
import { DeadlineChangeModalComponent } from '../../common/modal/deadline-change-modal/deadline-change-modal.component';
import { AppraiseeService } from '../../services/appraisee.service';
import { ClipboardCopyService } from '../../services/clibpboardCopy.service';
import { ProcessService } from '../../services/process.service';

const stylePathForPdfGenerator = 'assets\\styles\\pdf_css\\';
const bootstrapStyleName = 'bootstrap.min.css';
const commonStyleName = 'styles.css';
const briefReportStyleName = 'brief-report.css';
const combinedReportSufix = 'combined';

@Component({
  selector: 'app-detailed-process',
  templateUrl: './detailed-process.component.html',
  styleUrls: ['./detailed-process.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailedProcessComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput') fileInput: ElementRef;

  processDetail: ProcessDetail;
  appraiseeProcessDetails: Array<AppraiseeProcessDetail>;
  detailedCombinedReport: IndividualDetailReport;
  gradeItems: Array<NgxItem>;
  processDetailItem: Array<NgxItem>;
  selectedProcessDurationId: number;
  appraiseeItems: Array<NgxItem>;
  respondentItems: Array<NgxItem>;
  selectBusinessUnit = new FormControl();
  selectAppraisee = new FormControl();
  selectRespondent = new FormControl();
  selectGrade = new FormControl();
  processDetailFilter: ProcessDetailFilter = {};
  modalRef: BsModalRef;
  notificationType = ProcessActionNotificationType;
  processStage = ProcessStage;
  selectedNotificationType: ProcessActionNotificationType;
  isSpinnerEnable: boolean;
  isCombinedReportClicked: boolean;
  processInfo: ProcessInfoReport = {};
  pageNumber: number = 1;
  pageSize: number = 10;
  @ViewChild('combinedReportContent') combinedReportContent: ElementRef;
  appraiseeBlockVisible: boolean;
  respondentBlockVisible: boolean;
  pmBlockVisible: boolean;
  hrBlockVisible: boolean;
  addRespondentsVisible: boolean;
  isDateSelected: boolean;
  isSelectActiveAvailable: boolean;

  get showProcessReopenButton() {
    return this.appraiseeProcessDetails.some(
      (d) => d.stage === ProcessDurationAppraiseeStage.Completed
    );
  }

  private processId: string;
  private subscriptions = new Subscription();
  private readonly dateFormat: string = 'DD.MM.YYYY';
  private decimalScale = 10;
  private reportSubscription = new Subscription();
  private styleContent: string;

  constructor(
    private processDetailService: ProcessDetailService,
    private processService: ProcessService,
    private appraiseeService: AppraiseeService,
    private processParticipationService: ProcessParticipationService,
    private route: ActivatedRoute,
    private readonly reportingService: ReportingService,
    private readonly configService: ConfigService,
    private bsModalService: BsModalService,
    private ref: ChangeDetectorRef,
    private toastr: ToastrService,
    private readonly clipboardCopyService: ClipboardCopyService
  ) {
    this.styleContent = `<link rel=\"stylesheet\" type=\"text / css\" href=\"${
      stylePathForPdfGenerator + bootstrapStyleName
    }">
        <link rel=\"stylesheet\" type=\"text / css\" href=\"${
          stylePathForPdfGenerator + commonStyleName
        }\">
        <link rel=\"stylesheet\" type=\"text / css\" href=\"${
          stylePathForPdfGenerator + briefReportStyleName
        }\">`;
  }

  ngOnInit() {
    this.processId = this.route.snapshot.paramMap.get('id');
    this.selectedProcessDurationId = +this.route.snapshot.paramMap.get(
      'durationId'
    );
    this.loadProcessDetail();
    this.formControlSubscriber();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  canRespondentsBeDeleted(): boolean {
    return !this.appraiseeProcessDetails.some((pd) => pd.isAppraiseeSelected);
  }

  changePageNumber(newPageNumber: number) {
    this.pageNumber = newPageNumber;
  }

  isCombinedProcesses(
    appraiseeProcessDetails: Array<AppraiseeProcessDetail>
  ): boolean {
    return appraiseeProcessDetails.some(
      (a) =>
        a.appraisee === null &&
        a.respondents.filter((r) => r.state == RespondentState.InProcess)
          .length === 0
    );
  }

  showCombinedReport(processDetail: ProcessDetail) {
    this.isSpinnerEnable = true;
    this.reportSubscription = this.reportingService
      .getCombinedDetailReportData(processDetail.processId)
      .subscribe((x) => {
        this.detailedCombinedReport = x;
        this.processInfo.name = x.processName;
        this.isCombinedReportClicked = true;
        this.isSpinnerEnable = false;
        this.ref.detectChanges();
      });
  }

  hideCombinedReport() {
    this.detailedCombinedReport = null;
    this.reportSubscription.unsubscribe();
    this.isCombinedReportClicked = false;
  }

  downloadPdf() {
    const htmlForCombinedReportPdf = this.getHtmlForcombinedReport();
    this.isSpinnerEnable = true;
    this.reportingService
      .generatePdf(this.styleContent + htmlForCombinedReportPdf)
      .subscribe((blob) => {
        FileSaver.saveAs(
          blob,
          `${this.detailedCombinedReport.processName.replace(
            ' ',
            '_'
          )}_${combinedReportSufix}.pdf`
        );
        this.isSpinnerEnable = false;
        this.ref.markForCheck();
      });
  }

  selectProcessDuration(data: number) {
    this.selectedProcessDurationId = data;
    this.loadProcessDetail();
  }

  getDatesRange(processDurations: Array<ProcessDuration>): Array<NgxItem> {
    this.processDetailItem = processDurations.map((x) =>
      Object.assign({}, {
        id: x.id,
        text: `${moment(x.startDate).format(this.dateFormat)} - ${moment(
          x.endDate
        ).format(this.dateFormat)}`,
      } as NgxItem)
    );
    this.sortTextStrings(this.processDetailItem);
    return this.processDetailItem;
  }

  toggleSelectParent(appraiseeProcessDetail) {
    appraiseeProcessDetail.isAppraiseeSelected = !appraiseeProcessDetail.isAppraiseeSelected;
  }

  clearSelection() {
    this.appraiseeProcessDetails.forEach((a) => {
      a.isAppraiseeSelected = false;
    });
  }

  selectAll() {
    this.appraiseeProcessDetails.forEach((a) => {
      a.isAppraiseeSelected = true;
    });
  }

  getSelectedProcesses() {
    return this.appraiseeProcessDetails.filter((a) => a.isAppraiseeSelected);
  }

  selectAllActive() {
    return this.appraiseeProcessDetails
      .filter((a) => a.stage == ProcessDurationAppraiseeStage.Active)
      .forEach((a) => {
        a.isAppraiseeSelected = true;
      });
  }

  isDeadlineChangingAvailable() {
    let selected = this.appraiseeProcessDetails.filter(
      (a) => a.isAppraiseeSelected
    );
    return (
      selected.length > 0 &&
      this.processDetail.stage == ProcessStage.Active &&
      selected.every(
        (a) =>
          a.stage != ProcessDurationAppraiseeStage.Cancelled &&
          a.stage != ProcessDurationAppraiseeStage.Completed
      )
    );
  }

  getIsImportBtnEnabled() {
    return (
      this.processDetail.stage === ProcessStage.Active ||
      this.processDetail.stage === ProcessStage.Pending
    );
  }

  getBusinessUnits(
    appraiseeProcessDetails: Array<AppraiseeProcessDetail>
  ): Array<NgxItem> {
    const appraiseePD = appraiseeProcessDetails
      .filter((a) => a.appraisee)
      .map((x) =>
        Object.assign(
          {},
          {
            id: x.appraisee.businessUnitDisplayName,
            text: x.appraisee.businessUnitDisplayName,
          }
        )
      );
    const uniqueBusinessUnits = this.removeDuplicates(appraiseePD);
    this.sortTextStrings(uniqueBusinessUnits);
    return uniqueBusinessUnits;
  }

  filterProcessDetail() {
    this.appraiseeProcessDetails = this.filterProcessDetailByAppraisee(
      this.processDetail.appraiseeProcessDetails,
      this.processDetailFilter.appraiseeId
    );
    this.appraiseeProcessDetails = this.filterProcessDetailByBU(
      this.appraiseeProcessDetails,
      this.processDetailFilter.businessUnit
    );
    this.appraiseeProcessDetails = this.filterProcessDetailByGradeLevel(
      this.appraiseeProcessDetails,
      this.processDetailFilter.grade
    );
    this.appraiseeProcessDetails = this.filterProcessDetailByRespondent(
      this.appraiseeProcessDetails,
      this.processDetailFilter.respondentId
    );
    this.sortByAppraiseeName(this.appraiseeProcessDetails);
  }

  removeAppraisee() {
    this.selectAppraisee.setValue(undefined);
    this.processDetailFilter.appraiseeId = undefined;
    this.filterProcessDetail();
  }

  removeBusinessUnit() {
    this.selectBusinessUnit.setValue(undefined);
    this.processDetailFilter.businessUnit = undefined;
    this.filterProcessDetail();
  }

  removeGrade() {
    this.selectGrade.setValue(undefined);
    this.processDetailFilter.grade = undefined;
    this.filterProcessDetail();
  }

  removeRespondent() {
    this.selectRespondent.setValue(undefined);
    this.processDetailFilter.respondentId = undefined;
    this.filterProcessDetail();
  }

  async cancelSelectedParticipations(
    participations: Array<ProcessParticipation>
  ) {
    this.processDetail = await this.processParticipationService
      .cancel(this.selectedProcessDurationId, participations)
      .toPromise();
    this.filterProcessDetail();
    this.ref.detectChanges();
  }

  async deleteSelectedRespondents(participations: Array<ProcessParticipation>) {
    this.processDetail = await this.processParticipationService
      .deleteRespondents(this.selectedProcessDurationId, participations)
      .toPromise();
    this.filterProcessDetail();
    this.ref.detectChanges();
  }

  async cancelProcess() {
    this.processDetail = await this.processDetailService
      .cancelProcess(+this.processId, this.selectedProcessDurationId)
      .toPromise();
    this.toastr.success('The process was cancelled');
  }

  async sendHrSummary() {
    this.toastr.info("Notifications sending started");
    this.processService.sendHrSummaryNotification([+this.processId])
    .subscribe(() => this.toastr.success("Notifications were sent successfully"), _ => this.toastr.error("An error while sending the notifications"));
  }

  updateReportForSelected(
    participations: Array<AppraiseeProcessDetail>,
    processName: string
  ) {
    const selectedAppraisee = participations.find(
      (pd) => pd.isAppraiseeSelected
    );
    if (!selectedAppraisee) {
      return;
    }
    this.reportingService
      .updateAppraiseeReport(selectedAppraisee.processDurationAppraiseeId)
      .subscribe(() => this.modalRef.hide());
  }

  downloadIndividualReport(
    participations: Array<AppraiseeProcessDetail>,
    processName: string
  ) {
    const selectedAppraisee = participations.find(
      (pd) => pd.isAppraiseeSelected
    );
    if (!selectedAppraisee) {
      return;
    }
    const reportName =
      selectedAppraisee.appraisee !== null
        ? `Individual appraisee report - ${selectedAppraisee.appraisee.name}.xlsx`
        : `${processName + combinedReportSufix} report.xlsx`;
    this.reportingService
      .getIndividualAppraiseeExcelReport(
        parseInt(this.processId, this.decimalScale),
        selectedAppraisee.processDurationAppraiseeId
      )
      .subscribe((r) => saveAs(r, reportName));
  }

  downloadExcelReport(processName: string) {
    this.reportingService
      .getSummaryExcelReport(parseInt(this.processId, this.decimalScale))
      .subscribe((r) => saveAs(r, `Summary report - ${processName}.xlsx`));
  }

  exportSelectedParticipations(participations: Array<ProcessParticipation>) {
    this.processParticipationService
      .exportSelected(
        parseInt(this.processId, this.decimalScale),
        participations
      )
      .subscribe((r) =>
        saveAs(r, `Exported_respondents ${new Date().toISOString()}.xlsx`)
      );
  }

  async getFile(event: any) {
    this.setSpinnerStatus(true);
    if (!event.target.files || !(event.target.files.length > 0)) {
      this.setSpinnerStatus(false);
      return;
    }
    const file: File = event.target.files[0];
    if (!this.getIsExcelFile(file)) {
      this.setSpinnerStatus(false);
      return;
    }
    await this.uploadFile(file);
    this.setSpinnerStatus(false);
  }

  async uploadFile(file: File) {
    const fileToUpload = {
      id: this.selectedProcessDurationId,
      file: file,
      name: file.name,
    };
    this.fileInput.nativeElement.value = '';
    this.processDetail = await this.processParticipationService
      .updateNotCompleted(fileToUpload)
      .toPromise();
    this.filterProcessDetail();
    this.ref.detectChanges();
  }

  openModalByTemplate(modalTemplate: TemplateRef<any>) {
    this.modalRef = this.bsModalService.show(modalTemplate);
  }

  async openReopenProcessModal() {
    this.modalRef = this.bsModalService.show(ReopenProcessModalComponent, {
      initialState: { processDetail: this.processDetail },
    } as ModalOptions);
    this.bsModalService.onHidden.pipe(first()).subscribe(() => {
      if (!this.modalRef.content.isReopened) return;
      this.loadProcessDetail();
    });
  }

  async openAddRespondentModal() {
    this.modalRef = this.bsModalService.show(AddRespondentComponent, {
      initialState: {
        knownProcessTypes: this.processDetail.processKnownTypes,
        respondentSelectionValues: this.processDetail.respondentSelectionValues,
        isMultipleMode: true,
        processDurationAppraiseeIds: this.appraiseeProcessDetails
          .filter((pd) => pd.isAppraiseeSelected)
          .map((d) => d.processDurationAppraiseeId),
      },
    } as ModalOptions);
    this.bsModalService.onHidden.pipe(first()).subscribe(() => {
      if (!this.modalRef.content.isAdded) return;
      this.loadProcessDetail();
    });
  }

  openModal(
    modalTemplate: TemplateRef<any>,
    notificationType: ProcessActionNotificationType
  ) {
    this.openModalByTemplate(modalTemplate);
    this.selectedNotificationType = notificationType;
  }

  sendToAll() {
    this.processParticipationService
      .notifyAll(this.selectedNotificationType, this.selectedProcessDurationId)
      .subscribe(() => this.hideModal());
  }

  sendToSelected(participations: Array<ProcessParticipation>) {
    this.processParticipationService
      .notifySelected(this.selectedNotificationType, participations)
      .subscribe(() => this.hideModal());
  }

  getSelected(): Array<ProcessParticipation> {
    return this.appraiseeProcessDetails
      .filter(
        (pd) =>
          pd.isAppraiseeSelected || pd.respondents.some((r) => r.isSelected)
      )
      .map(this.mapToProcessParticipation);
  }

  getSelectedRespondents(): Array<ProcessParticipation> {
    return this.appraiseeProcessDetails
      .filter((pd) => pd.respondents.some((r) => r.isSelected))
      .map(this.mapToProcessParticipation);
  }

  setSpinnerStatus(isEnabled: boolean) {
    this.isSpinnerEnable = isEnabled;
    this.ref.detectChanges();
  }

  validateMenu() {
    let selectedAppraisees = this.getSelectedProcesses();
    this.addRespondentsVisible =
      !selectedAppraisees.some(
        (a) =>
          a.stage == ProcessDurationAppraiseeStage.Cancelled ||
          a.stage == ProcessDurationAppraiseeStage.Completed
      ) &&
      this.processDetail.stage == ProcessStage.Active &&
      selectedAppraisees.length > 0;
  }

  getMinDate() {
    const duration = this.processDetail.processDurations.find(
      (d) => this.selectedProcessDurationId === d.id
    );
    const startDate = moment(duration.startDate).toDate();
    const today = new Date();
    return today > startDate ? today : startDate;
  }

  generateLink(processId: number) {
    let text = `${
      this.configService.apiUrl
    }/api/process/GenerateLink?processId=${processId.toString()}`;
    this.clipboardCopyService.copyTextToClipboard(text);
  }

  async onChangeDeadlineClicked() {
    let minDate = this.getMinDate();
    this.modalRef = this.bsModalService.show(DeadlineChangeModalComponent, {
      initialState: { minDate: minDate },
    } as ModalOptions);
    this.bsModalService.onHidden.pipe(first()).subscribe(async () => {
      if (!this.modalRef.content.isSaveClicked) return;
      await this.appraiseeService
        .changeDeadline(
          this.modalRef.content.date,
          this.getSelectedProcesses().map((c) => c.processDurationAppraiseeId)
        )
        .toPromise();
      this.loadProcessDetail();
    });
  }

  getGrades(appraiseeProcessDetails: Array<AppraiseeProcessDetail>) {
    const greades = appraiseeProcessDetails
      .filter((a) => a.appraisee)
      .map((x) =>
        Object.assign(
          {},
          {
            id: x.appraisee.grade,
            text: x.appraisee.grade,
            customValue: x.appraisee.gradeLevel,
          }
        )
      );
    this.gradeItems = this.removeDuplicates(greades);
    this.sortCustomValueNumbers(this.gradeItems);
    return this.gradeItems;
  }

  getAppraisees(appraiseeProcessDetails: Array<AppraiseeProcessDetail>) {
    const appraisees = appraiseeProcessDetails
      .filter((a) => a.appraisee)
      .map((x) =>
        Object.assign(
          {},
          {
            id: x.appraisee.id,
            text: x.appraisee.name,
          }
        )
      );
    this.appraiseeItems = this.removeDuplicates(appraisees);
    this.sortTextStrings(this.appraiseeItems);
    return this.appraiseeItems;
  }

  getRespondents(appraiseeProcessDetails: Array<AppraiseeProcessDetail>) {
    let respondents = appraiseeProcessDetails.reduce(
      (res, a) => [...res, ...a.respondents],
      []
    );
    respondents = respondents.map((x) =>
      Object.assign(
        {},
        {
          id: x.id,
          text: x.name,
        }
      )
    );
    this.respondentItems = this.removeDuplicates(respondents);
    this.sortTextStrings(this.respondentItems);
    return this.respondentItems;
  }

  private getHtmlForcombinedReport(): string {
    return this.combinedReportContent.nativeElement.innerHTML;
  }

  private hideModal() {
    if (!this.modalRef) {
      return;
    }
    this.modalRef.hide();
  }

  private async loadProcessDetail() {
    this.processDetail = await this.processDetailService
      .getProcessDetail(this.selectedProcessDurationId)
      .toPromise();
    this.filterProcessDetail();
    this.isSelectActiveAvailable =
      this.processDetail.stage == ProcessStage.Active;
    this.ref.detectChanges();
  }

  private mapToProcessParticipation(
    source: AppraiseeProcessDetail
  ): ProcessParticipation {
    return Object.assign({
      processDurationAppraiseeId: source.processDurationAppraiseeId,
      appraisee: source.appraisee,
      respondents: source.respondents.filter((r) => r.isSelected),
      isAppraiseeSelected: source.isAppraiseeSelected,
    }) as ProcessParticipation;
  }

  private formControlSubscriber() {
    const appraiseeSubscription = this.selectAppraisee.valueChanges.subscribe(
      (x) => {
        this.processDetailFilter.appraiseeId = +x;
        this.filterProcessDetail();
      }
    );
    this.subscriptions.add(appraiseeSubscription);

    const respondentSubscription = this.selectRespondent.valueChanges.subscribe(
      (x) => {
        this.processDetailFilter.respondentId = +x;
        this.filterProcessDetail();
      }
    );
    this.subscriptions.add(respondentSubscription);

    const buSubscription = this.selectBusinessUnit.valueChanges.subscribe(
      (x) => {
        this.processDetailFilter.businessUnit = x;
        this.filterProcessDetail();
      }
    );
    this.subscriptions.add(buSubscription);

    const gradeSubscription = this.selectGrade.valueChanges.subscribe((x) => {
      this.processDetailFilter.grade = x;
      this.filterProcessDetail();
    });
    this.subscriptions.add(gradeSubscription);
  }

  private filterProcessDetailByAppraisee(
    appraiseeProcessDetails: Array<AppraiseeProcessDetail>,
    appraiseeId: number
  ): Array<AppraiseeProcessDetail> {
    return appraiseeId
      ? appraiseeProcessDetails.filter((x) => x.appraisee.id === appraiseeId)
      : appraiseeProcessDetails;
  }

  private filterProcessDetailByRespondent(
    appraiseeProcessDetails: Array<AppraiseeProcessDetail>,
    respondentId: number
  ): Array<AppraiseeProcessDetail> {
    return respondentId
      ? appraiseeProcessDetails.filter((x) =>
          x.respondents.some((r) => r.id == respondentId)
        )
      : appraiseeProcessDetails;
  }

  private filterProcessDetailByBU(
    appraiseeProcessDetails: Array<AppraiseeProcessDetail>,
    businessUnit: string
  ): Array<AppraiseeProcessDetail> {
    const appraiseePD = businessUnit
      ? appraiseeProcessDetails.filter(
          (x) => x.appraisee.businessUnitDisplayName === businessUnit
        )
      : appraiseeProcessDetails;
    return appraiseePD;
  }

  private filterProcessDetailByGradeLevel(
    appraiseeProcessDetails: Array<AppraiseeProcessDetail>,
    grade: string
  ): Array<AppraiseeProcessDetail> {
    const appraiseePD = grade
      ? appraiseeProcessDetails.filter((x) => x.appraisee.grade === grade)
      : appraiseeProcessDetails;
    return appraiseePD;
  }

  private sortCustomValueNumbers(ngxItems: Array<NgxItem>) {
    ngxItems.sort((a, b) => {
      return +b.customValue - +a.customValue;
    });
  }

  private sortTextStrings(ngxItems: Array<NgxItem>) {
    ngxItems.sort((a, b) => a.text.localeCompare(b.text));
  }

  private sortByAppraiseeName(
    appraiseeProcessDetails: Array<AppraiseeProcessDetail>
  ) {
    appraiseeProcessDetails.sort((a, b) =>
      a.appraisee.name.localeCompare(b.appraisee.name)
    );
  }

  private removeDuplicates(objArray: Array<NgxItem>): Array<NgxItem> {
    return objArray.filter(
      (obj, pos, arr) => arr.findIndex((x) => x.text === obj.text) === pos
    );
  }

  private getIsExcelFile(file: File): boolean {
    return this.configService.configData.excelMIMETypes.some(
      (x) => x === file.type
    );
  }
}
